import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';
import isEmbedded from '@/utils/is-embedded';

export function getTeammateAppRevisionQueryParam() {
  const currentURL = window.location.href;
  const url = new URL(currentURL);
  return url.searchParams.get('teammate_app_rev');
}

export const sentryConfig: Sentry.BrowserOptions = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_RELEASE_VERSION,
  transport: Sentry.makeFetchTransport,
  stackParser: Sentry.defaultStackParser,
  maxValueLength: 500,
  beforeSend: (event) => {
    event.tags = event.tags ?? {};
    event.tags.is_embedded = isEmbedded().toString();
    event.tags.url = window.location.href;
    event.contexts = event.contexts ?? {};
    event.contexts.browser = {
      userAgent: navigator.userAgent,
    };

    if (typeof event.extra?.zodSentryMessage === 'string') {
      const exception = event.exception?.values?.[0];
      if (exception) {
        exception.value = event.extra.zodSentryMessage;
        if (typeof event.extra.zodSchemaName === 'string') {
          exception.type = `ZodError(${event.extra.zodSchemaName})`;
        }
      }
    }

    return event;
  },
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 0,
};
